<template>
  <div class="dropdown" :class="{active: active}">
    <div v-click-outside="outside">
      <i class="dropdown-arrow" v-if="query=='' || !active"></i>
      <i class="dropdown-close" v-else @click="query=''"></i>
      <input autocapitalize="off" ref="dropdown" v-if="active" v-model="query" />
      <span @click="open()" v-else>{{value.name}}</span>
      <ul v-show="active && items_list.length>0">
        <li
          v-for="(item, key) in items_list"
          :key="Math.random()"
          @click="select(item)"
        >{{item.name}}</li>
      </ul>
      <ul v-show="active && items_list.length==0">
        <li>Results not found</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'items', 'selected', 'type'],
  data () {
    return {
      active: false,
      query: '',
      first_open: true
    }
  },
  methods: {
    open () {
      var self = this
      self.active = true
      this.first_open = true
      setTimeout(function () {
        self.$refs.dropdown.focus()
      }, 200)
    },
    select (item) {
      this.active = false
      //this.$emit('choose_dropdown', item, this.type)
      this.$emit('input', item)
    },
    outside: function (e) {
      if (!this.first_open) {
        this.active = false
      }
      this.first_open = false
    },
    inside: function (e) {
      console.log('clicked inside!')
    },
    getSelectedItem () {
      return this.items.find(item => item.id === this.selected)
    }
  },
  created () {
    // if (this.type == 'billing_state' || this.type == 'shipping_state') {
    //   var selected_irem = this.getSelectedItem()
    //   if (selected_irem) {
    //     this.value = selected_irem.name
    //     this.$emit('choose_dropdown', selected_irem, this.type)
    //   }
    // }
    // this.$emit('choose_dropdown', item, this.type)
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) {
            warn += `Found in component '${compName}'`
          }

          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  },
  watch: {
    items (to, from) {
      var selected_irem = this.getSelectedItem()
      if (selected_irem) {
        this.value = selected_irem.name
        this.$emit('choose_dropdown', selected_irem, this.type)
      }
    }
  },
  computed: {
    items_list () {
      var self = this
      return self.items.filter(function (item) {
        return item.name.toLowerCase().search(self.query.toLowerCase()) > -1
      })
    }
  }
}
</script>

<style lang="scss">
.dropdown {
  height: 45px;
  overflow: hidden;
  position: relative;

  &.active {
    overflow: visible;
    z-index: 10;

    .dropdown-arrow {
      @include rotate(135);
      top: 8px;
    }
  }

  .dropdown-arrow,
  .dropdown-close {
    content: "";
    display: block;
    position: absolute;
    right: 15px;
    bottom: 0;
    margin: auto;
  }

  .dropdown-arrow {
    width: 12px;
    height: 12px;
    top: -5px;
    border-left: 1px solid #696969;
    border-bottom: 1px solid #696969;
    @include rotate(-45);
  }

  .dropdown-close {
    width: 14px;
    height: 14px;
    top: 0;
    cursor: pointer;
    &:after,
    &:before {
      content: "";
      border-bottom: 1px solid #000;
      left: 0;
      right: 0;
      top: 7px;
      position: absolute;
    }
    &:before {
      @include rotate(45);
    }
    &:after {
      @include rotate(-45);
    }
  }

  span {
    display: block;
    border: 1px solid #ccc;
    height: 45px;
    line-height: 45px;
    padding-left: 15px;
    font-size: 16px;
    cursor: pointer;
    position: relative;
  }
  ul {
    max-height: 250px;
    overflow: auto;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0px 2px 6px #0000001a;
    background: #ffff;
    li {
      line-height: 35px;
      border-bottom: 1px solid rgba(193, 193, 193, 0.2);
      border-left: 1px solid rgba(0, 0, 0, 0.2);
      padding-left: 15px;
      padding-right: 15px;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        background: rgba(193, 193, 193, 0.2);
      }
    }
  }
}
</style>
